export default "__VITE_ASSET__4df6baea__"